"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEventSignature = void 0;
var toSignature_js_1 = require("./toSignature.js");
Object.defineProperty(exports, "toEventSignature", { enumerable: true, get: function () { return toSignature_js_1.toSignature; } });
//# sourceMappingURL=toEventSignature.js.map